import { FC } from 'react'
import { Tabs } from 'antd'
import shallow from 'zustand/shallow'
import { useAuth } from '../../context/auth-context'
import { useCompanySettingsStore } from './CompanySettingsStore'
import { CompanySettingsAppraisalTab } from './appraisal/AppraisalTab'
import { CompanySettingsMeetingRequestsTab } from './meetingRequests/CompanySettingsMeetingRequestsTab'
import { CompanySettingsReviewerTab } from './reviewer/CompanySettingsReviewerTab'
import { CompanySettingsTargetsTemplatesTab } from './targetTemplate/CompanySettingsTargetsTemplatesTab'
import { CompanySettingsTabs } from './types'
import { getCompanySettingsPermissionInfo } from '../../shared/permissions/permission-helper'
import { CompanySettingsPermissions } from './permissions'
import { CompanySettingsTargetsReportsTab } from './targetReports/CompanySettingsTargetsReportsTab'
import { CompanySettingsCultivatingTalentsTab } from './cultivatingTalents/CompanySettingsCultivatingTalentsTab'
import useIsFeatureEnabled from '../../graphql/featureToggle/useIsFeatureEnabled'
import { FeatureNameEnum } from '../../graphql/featureToggle/FeatureNameEnum'
import { CompanySettingsEmployeesTab } from './employees/EmployeesTab'

const { TabPane } = Tabs

export const CompanySettingsContent: FC = () => {
  const { user } = useAuth()
  const [activeTab] = useCompanySettingsStore((state) => [state.activeTab], shallow)

  const { isFeatureEnabled: rankingPhaseTwoEnabled } = useIsFeatureEnabled(FeatureNameEnum.TALENTS_SEASON)

  const companySettingsPermissionInfo = getCompanySettingsPermissionInfo(user.roles ? user.roles : [])

  return (
    <Tabs activeKey={activeTab} renderTabBar={() => <></>}>
      {companySettingsPermissionInfo[CompanySettingsPermissions.appraisalsTab] && (
        <TabPane key={CompanySettingsTabs.appraisal}>
          <CompanySettingsAppraisalTab />
        </TabPane>
      )}

      {companySettingsPermissionInfo[CompanySettingsPermissions.companyMeetingRequests] && (
        <TabPane key={CompanySettingsTabs.requests}>
          <CompanySettingsMeetingRequestsTab />
        </TabPane>
      )}

      {companySettingsPermissionInfo[CompanySettingsPermissions.reviewerTab] && (
        <TabPane key={CompanySettingsTabs.reviewer}>
          <CompanySettingsReviewerTab />
        </TabPane>
      )}

      {companySettingsPermissionInfo[CompanySettingsPermissions.employeesTab] && (
        <TabPane key={CompanySettingsTabs.employees}>
          <CompanySettingsEmployeesTab />
        </TabPane>
      )}

      {companySettingsPermissionInfo[CompanySettingsPermissions.cultivatingTalentsTab] && !!rankingPhaseTwoEnabled && (
        <TabPane key={CompanySettingsTabs.cultivatingTalents}>
          <CompanySettingsCultivatingTalentsTab isYourCompanyView={true} />
        </TabPane>
      )}

      {companySettingsPermissionInfo[CompanySettingsPermissions.targetTemplatesTab] && (
        <TabPane key={CompanySettingsTabs.targetTemplate}>
          <CompanySettingsTargetsTemplatesTab />
        </TabPane>
      )}

      {companySettingsPermissionInfo[CompanySettingsPermissions.targetReportsTab] && (
        <TabPane key={CompanySettingsTabs.targetReports}>
          <CompanySettingsTargetsReportsTab />
        </TabPane>
      )}
    </Tabs>
  )
}
